import React, { useEffect, useState } from "react";
import {
    makeStyles,
    lighten,
    Tooltip,
    Grid,
    Typography,
    TextField,
    Paper,
    Box,
    IconButton,
    FormControl,
    FormLabel,
    FormControlLabel,
    Button,
    ButtonGroup,
    Radio,
    RadioGroup,
    Divider,
  } from "@material-ui/core";

import clsx from "clsx";
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import BuildIcon from '@material-ui/icons/Build';
import AddIcon from "@material-ui/icons/Add"

import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import {getInspection, setInspectionDraft, getInspections, getInspectionsByUser} from "../../actions/awpAction"
import ServiceInspectionModal from "../Modals/AWP/ServiceInspectionModal";
import Feedback from "../../utils/Feedback"

const useStyles = makeStyles((theme) => ({

    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
      },
    
      title: {
        // color: "#707070",
        padding: theme.spacing(2),
        marginBottom: 40,
        color: lighten(theme.palette.common.black, 0.75),
    
        display: "block",
        fontSize: 14,
        fontWeight: 900,
      },
      
      title2: {
        fontSize: 13,
        marginBottom: 10,
        fontWeight: "bold",
    
        },
    
      time: {
        // marginLeft: "auto",
        marginTop: 10,
    
        // width: 120,
        width: "fit-content",
        height: 40,
        padding: theme.spacing(1),
        // textAlign: "center",
        margin: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      icon: {
        marginRight: 5,
      },
      btnLink: {
        padding: theme.spacing(1.5),
        marginTop: -90,
        width: 200,
        [theme.breakpoints.down("xs")]: {
          width: "40%",
        },
      },
      btn: {
        marginLeft: 20,
        marginBottom: 30,
      },
    
      btnGroup: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        [theme.breakpoints.down("xs")]: {
            width: "100%",
          },
    
      },
      dialog: {
        position: "relative",
        [theme.breakpoints.down("sm")]: {
          width: "100%",
          height: "100%",
        },
      },
      formControl: {
          minWidth: 380,
          [theme.breakpoints.down("sm")]: {
              width: "100%",
          },
          [theme.breakpoints.down("xs")]: {
              minWidth: "100%",
          },
      },
      formcontrol2: {
        textAlign: "left",
        minWidth: 350,
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
        [theme.breakpoints.down("xs")]: {
          minWidth: "100%",
        },
      },
      paper: {
          padding: theme.spacing(4),
          textAlign: "center",
          color: theme.palette.text.secondary,
          marginLeft: 20,
      },
      [theme.breakpoints.down("sm")]: {
          width: "100%",
      },
      [theme.breakpoints.down("xs")]: {
          minWidth: "100%",
      },
      
      typo : {
        fontWeight: "bold",
        fontSize: 13,
      },
      statusDarkGreen: {
        borderColor: "#4caf50",
        color: "#4caf50",
      },
      paper3:{
        textAlign: "center",
        width: "fit-content",
        height: 50,
        display: "flex",
        justifyContent: "center",
        marginTop: -70
      },
    
}));

const INIT_STATE = {
    unitNumber: "",
    inspector: "",
    supervisor: undefined,
    date: "",
    location: undefined,
    visualDamage:"1",
    reason:"",
    fireExtinguisher: "1",
    deadmanSwitch: "1",
    groundControl: "1",
    limitSwitches: "1",
    tiltAlarm: "1",
    tires: "1",
    greasedRotator: "1",
    leaks: "1",
    doors:"1",
    engineOil:"1",
    coolant:"1",
    exhaust:"1",
    beltCondition:"1",
    hydraulicOil:"1",
    hoses:"1",
    auxilliaryMotor:"1",
    guages:"1",
    battery:"1",
    glowPlug: "1",
    keyPlatform: "1",
    joysticks: "1",
    toggleSwitches: "1",
    functions: "1",
    platformDoors: "1",
    footPadal: "1",
    safetyDecals: "1",
    platformToe: "1",
    handrails: "1",
    horn: "1",
    comment:"",
    fuel:"",
    nextService:"",
    service: {
      date:"",
      description:"",
      servicedBy: "",
      cost: ""
    },
    error: null,
    success: false,
    loading: false,
};

const AWPInspectionView = () => {
  const { id } = useParams();
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const [state, setState] = useState(INIT_STATE);
  const [feed, setFeed] = React.useState({
    loading: false,
    open: false,
    message: "",
    success: false,
  });


  const {error, awp } = useSelector((state) => state.awp);
  const { profile, loading } = useSelector((state) => state.users);

  const [openEdit, setOpenEdit] = useState(false);
  const [openService, setOpenService] = useState(false);
  const [getId, setGetId] = useState("");

    let isAdminGuard = profile
    ? (profile &&
        profile.role && profile.role.map((role) => role.name).includes("admin"))
    : false;

    let isAWPAdmin = profile
    ? (profile &&
        profile.role && profile.role.map((role) => role.name).includes("awp_admin"))
        : false;

    useEffect(() => {
        if (id){
            dispatch(getInspection(id));
        }
        }, [dispatch, id]);
    
    useEffect(() => {
        const abortController = new AbortController();
        if (error && error !== null) {
            setFeed((prev) => ({
            loading: false,
            open: true,
            message: error,
            success: false,
            }));
        }
        return () => {
            abortController.abort();
        };
    }, [error]);

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            unitNumber: awp && awp.unitNumber,
            inspector: awp && awp.inspector,
            supervisor: awp && awp.supervisor,
            date: awp && awp.date,
            location: awp && awp.location?.displayname,
            visualDamage:awp && awp.visualDamage,
            reason:awp && awp.reason,
            fireExtinguisher: awp && awp.fireExtinguisher,
            deadmanSwitch: awp && awp.deadmanSwitch,
            groundControl: awp && awp.groundControl,
            limitSwitches: awp && awp.limitSwitches,
            tiltAlarm: awp && awp.tiltAlarm,
            tires: awp && awp.tires,
            greasedRotator: awp && awp.greasedRotator,
            leaks: awp && awp.leaks,
            doors:awp && awp.doors,
            engineOil:awp && awp.engineOil,
            coolant:awp && awp.coolant,
            exhaust:awp && awp.exhaust,
            beltCondition:awp && awp.beltCondition,
            hydraulicOil:awp && awp.hydraulicOil,
            hoses:awp && awp.hoses,
            auxilliaryMotor:awp && awp.auxilliaryMotor,
            guages:awp && awp.guages,
            battery:awp && awp.battery,
            glowPlug: awp && awp.glowPlug,
            keyPlatform: awp && awp.keyPlatform,
            joysticks: awp && awp.joysticks,
            toggleSwitches: awp && awp.toggleSwitches,
            functions: awp && awp.functions,
            platformDoors: awp && awp.platformDoors,
            footPadal: awp && awp.footPadal,
            safetyDecals: awp && awp.safetyDecals,
            platformToe: awp && awp.platformToe,
            handrails: awp && awp.handrails,
            horn: awp && awp.horn,
            comment:awp && awp.comment,
            fuel:awp && awp.fuel,
            nextService:awp && awp.nextService,
            service: awp && awp.service
    
        }));
        }, [awp]);

    const handleSetDraft = (e) => {
        e.preventDefault();
        dispatch(setInspectionDraft(id));
        setTimeout(() => {
            dispatch(getInspections());
            dispatch(getInspectionsByUser());
    
            setFeed((prev) => ({
                loading: false,
                open: true,
                message: "Inspection set to draft successfully!",
                success: true,
            }));
        }, 1500);
        };
    
    const handleOpenService = (id) => {
        setGetId(id);
        setOpenService(true);
    };
    
    const handleCloseService = () => {
        setOpenService(false);
    };

    const handleCloseFeed = () => {
        setFeed((prevState) => ({ ...prevState, open: false }));
    };
    
    const printRef = React.useRef()
    const handleDownloadPdf = async () => {
    const element = printRef.current
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4', true);
    
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight()
    const imgWidth = canvas.width
    const imgHeight = canvas.height
    const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight)
    const imgX = (pdfWidth - imgWidth * ratio) / 2
    const imgY = (pdfHeight - imgHeight * ratio) / 2

    pdf.addImage(data, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
    pdf.save(`AWP_${state.unitNumber}_${state.date?.split("T")[0]}.pdf`);
    }; 

  return (
    <div className={classes.root}>
    <ServiceInspectionModal {...{ openService, handleCloseService, id: getId }} />
      {feed.success ? (
        <Feedback
          handleCloseFeed={handleCloseFeed}
          open={feed.open}
          severity="success"
          message={feed.message}
        />
      ) : (
        <Feedback
          handleCloseFeed={handleCloseFeed}
          open={feed.open}
          severity="error"
          message={feed.message}
        />
      )}
        <Typography variant="overline" className={classes.title}>
            View AWP Inspection
        </Typography>
        <br/>
    
        {(awp && (awp.status === "Submitted" || awp.status === "Serviced")) && (isAdminGuard || isAWPAdmin) && (
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={8} sm={8}>
                <ButtonGroup className={classes.btnGroup} variant="outlined">
                    
                    <Button
                        size="small"
                        className={classes.btnLink}
                        color="primary"
                        onClick={handleSetDraft}
                    >
                        Set to Draft
                    </Button>
                    <Button
                        size="small"
                        className={clsx(classes.btnLink, classes.statusDarkGreen)}
                        onClick={handleDownloadPdf}
                    >
                        Download as PDF
                    </Button>
                </ButtonGroup>
            </Grid>

            <Grid item xs={4} sm={4}>
                <Paper variant="outlined" className={classes.paper3}>
                <IconButton color="primary" onClick={() => handleOpenService(awp._id)}>
                    <BuildIcon/>
                    <Tooltip title="Record Services & Repairs">
                        <AddIcon />
                    </Tooltip>
                </IconButton>
                </Paper>
            
            </Grid>
            </Grid>
            )}
            <br/>
      {/* <Divider/> */}
      <div ref={printRef}>
      <Paper className={classes.paper} variant="outlined">
          <Box sx={{ width: '100%', typography: 'body1' }}>

          <Grid container justifyContent="center" alignItems="center" spacing={3}>
            <Grid item xs={12} sm={6}>
                  <TextField
                      name="unitNumber"
                      fullWidth
                      variant="outlined"
                      label="Unit Number"
                      value={state.unitNumber || ""}
                      disabled
                    />
                </Grid>
              <Grid item xs={12} sm={6}>
                  <TextField
                      name="inspector"
                      fullWidth
                      variant="outlined"
                      label="Operator"
                      value={state.inspector || ""}
                      disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                      name="supervisor"
                      fullWidth
                      variant="outlined"
                      label="Supervisor"
                      value={state.supervisor?.displayname || ""}
                      disabled
                    />
                </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                    name="date"
                    fullWidth
                    variant="outlined"
                    label="Date"
                    value={state.date?.split("T")[0] || ''}
                    disabled    
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                    name="location"
                    fullWidth
                    variant="outlined"
                    label="Location"
                    value={state.location || ""}
                    disabled    
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                    name="fuel"
                    fullWidth
                    variant="outlined"
                    label="Fuel Level"
                    value={state.fuel || ""}
                    disabled
                />
              </Grid>
              <Grid item xs={12} sm={12}>
              <Typography variant="body2" gutterBottom color="primary">
                  1 - Ok;
                  2 - Requires Scheduled Maintenance;
                  3 - Requires Immediate Fix
                </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Walk Around Visual Damage Inspection</FormLabel>
                  <RadioGroup row aria-label="visualDamage" name="visualDamage" value={state.visualDamage || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              {(state.visualDamage == "2" || state.visualDamage == "3") && (
              <Grid item xs={12} sm={6}>
                  <TextField
                  name="reason"
                  fullWidth
                  variant="outlined"
                  label="Briefly describe the damage"
                  disabled
                  multiline
                  value={state.reason || ""}
                  />
              </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Fire Extinguisher</FormLabel>
                  <RadioGroup row name="fireExtinguisher" value={state.fireExtinguisher || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2"disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3"disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Deadman Switch</FormLabel>
                  <RadioGroup row name="deadmanSwitch" value={state.deadmanSwitch || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Ground Control Box</FormLabel>
                  <RadioGroup row name="groundControl" value={state.groundControl || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Limit Switches</FormLabel>
                  <RadioGroup row name="limitSwitches" value={state.limitSwitches || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Tilt Alarm</FormLabel>
                  <RadioGroup row name="tiltAlarm" value={state.tiltAlarm || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Tires and Lug Nuts</FormLabel>
                  <RadioGroup row name="tires" value={state.tires || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Greased Rotator Assembly</FormLabel>
                  <RadioGroup row name="greasedRotator" value={state.greasedRotator || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Leaks</FormLabel>
                  <RadioGroup row name="leaks" value={state.leaks || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Doors and Latches</FormLabel>
                  <RadioGroup row name="doors" value={state.doors || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Engine Oil Level</FormLabel>
                  <RadioGroup row name="engineOil" value={state.engineOil || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Coolant Level</FormLabel>
                  <RadioGroup row name="coolant" value={state.coolant || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Exhaust, Air Induction</FormLabel>
                  <RadioGroup row name="exhaust" value={state.exhaust || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Belt Condition and Tension</FormLabel>
                  <RadioGroup row name="beltCondition" value={state.beltCondition || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Hydraulic Oil Level</FormLabel>
                  <RadioGroup row name="hydraulicOil" value={state.hydraulicOil || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Hoses and Leaks</FormLabel>
                  <RadioGroup row name="hoses" value={state.hoses || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Auxilliary Motor</FormLabel>
                  <RadioGroup row name="auxilliaryMotor" value={state.auxilliaryMotor || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Guages</FormLabel>
                  <RadioGroup row name="guages" value={state.guages || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Battery Connections - Clean and Dry</FormLabel>
                  <RadioGroup row name="battery" value={state.battery || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Glow Plug - if equipped</FormLabel>
                  <RadioGroup row name="glowPlug" value={state.glowPlug || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Key Platform</FormLabel>
                  <RadioGroup row name="keyPlatform" value={state.keyPlatform || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Joysticks and Levers</FormLabel>
                  <RadioGroup row name="joysticks" value={state.joysticks || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >All Toggle Switches Functional</FormLabel>
                  <RadioGroup row name="toggleSwitches" value={state.toggleSwitches || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >All Functions Operational</FormLabel>
                  <RadioGroup row name="functions" value={state.functions || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Platform Doors or Safety Chain</FormLabel>
                  <RadioGroup row name="platformDoors" value={state.platformDoors || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Foot Pedal Operational</FormLabel>
                  <RadioGroup row name="footPedal" value={state.footPadal || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Safety Decals Good - Platform & Ground</FormLabel>
                  <RadioGroup row name="safetyDecals" value={state.safetyDecals || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Platform Toe Guards</FormLabel>
                  <RadioGroup row name="platformToe" value={state.platformToe || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Handrails</FormLabel>
                  <RadioGroup row name="handrails" value={state.handrails || ""} >
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl  variant="outlined" className={classes.formcontrol2}>
                  <FormLabel >Horn</FormLabel>
                  <RadioGroup row name="horn" value={state.horn || ""}>
                    <FormControlLabel value="1" control={<Radio color="primary"/>} label="1" disabled/>
                    <FormControlLabel value="2" control={<Radio color="secondary"/>} label="2" disabled/>
                    <FormControlLabel value="3" control={<Radio color="secondary"/>} label="3" disabled/>
                  </RadioGroup>
                </FormControl>
              </Grid>
              
              <Grid item xs={12} sm={6}>
              <TextField
                    name="nextService"
                    fullWidth
                    variant="outlined"
                    label=" Next Service Due Date"
                    disabled
                    value={state.nextService?.split("T")[0] || ''}
                    type="date"     
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                  <TextField
                  name="comment"
                  fullWidth
                  variant="outlined"
                  label="Comments/Rapairs Required"
                  multiline
                  value={state.comment || ""}
                  disabled
                  />
              </Grid>
              <Divider/>

            </Grid> 
            {awp && awp.service && (
              <Grid>
                <br/>
                <Divider/>
                <Typography variant="overline" className={classes.title}>
                  Services/Repairs Completed
                </Typography>
                <Grid container justifyContent="center" alignItems="center" spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                        name="serviceDate"
                        fullWidth
                        variant="outlined"
                        label="Service Date"
                        value={state.service?.date?.split("T")[0] || ""}
                        type="date"
                        disabled
                        size="small"     
                    />
                  </Grid>
                  
                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="description"
                      fullWidth
                      variant="outlined"
                      label="Description"
                      multiline
                      value={state.service?.description || ""}
                      disabled
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                        name="servicedBy"
                        fullWidth
                        variant="outlined"
                        label="Serviced By"
                        value={state.service?.servicedBy || ""}
                        disabled
                        size="small"    
                    />
                  </Grid>
                  
                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="cost"
                      fullWidth
                      variant="outlined"
                      label="Cost"
                      value={state.service?.cost || ""}
                      disabled
                      size="small"
                    />
                  </Grid>
                  </Grid>
                </Grid>
            )}
               
          </Box>
          </Paper>
          </div>
    </div>
  );
};

export default AWPInspectionView;